import React from 'react';
import locationContext from '../../context/locationsContext';
import { getCombinedSuggestions } from '../../utils/suggestionsUtils';
import SuggestionsList from '../Suggestions/SuggestionsList';
import { useLocationsSmartFillAPI, useRecentSearchData } from '../../hooks/apiHooks';

const LocationsSmartFill = () => {
  const {
    config: {
      lineOfBusiness,
      maximumResultsToShow,
    },
  } = React.useContext(locationContext);
  const recentSearches = useRecentSearchData();
  const { suggestions, isLoading, error } = useLocationsSmartFillAPI();

  if ((isLoading || error || suggestions?.length === 0) && recentSearches?.length === 0) {
    return null;
  }

  const suggestionsByType = getCombinedSuggestions({
    suggestions, recentSearches, maximumResultsToShow, lineOfBusiness,
  });

  return <SuggestionsList suggestions={suggestionsByType} />;
};

export default LocationsSmartFill;
